import {
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AuthService } from '../services/auth.service';

/**
 * Global HTTP error handling for tenant admin API calls.
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An error occurred';

      if (error.error?.message) {
        errorMessage = Array.isArray(error.error.message)
          ? error.error.message.join(', ')
          : error.error.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      switch (error.status) {
        case 401:
          authService.discardLocalSession();
          if (!router.url.startsWith('/auth/')) {
            void router.navigate(['/auth/login']);
          }
          break;

        case 403:
          if (!router.url.startsWith('/auth/access-denied')) {
            void router.navigate(['/auth/access-denied']);
          }
          break;

        case 0:
          errorMessage = 'Network error - please check your connection';
          break;

        default:
          break;
      }

      return throwError(() => ({
        ...error,
        errorMessage,
        errorCode: error.error?.error?.code,
        errorDetails: error.error?.details,
      }));
    }),
  );
};
